module.exports = __webpack_public_path__ + "static/img/aa-5.e58fda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-5.png
// module id = bB/+
// module chunks = 1